import React from 'react';
import PropTypes from 'prop-types';

function CreditPackage({ onClick, icon, iconUrl, title, subtitle }) {
  return (
    <button className="home-package" onClick={onClick} type="button" aria-label={title}>
      {/* ✅ Use iconUrl with inline styles if provided, otherwise use icon prop */}
      {iconUrl ? (
        <div 
          className="service-icon"
          aria-hidden="true"
          style={{
            backgroundImage: `url(${iconUrl})`,
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            width: '50px',
            height: '50px',
            display: 'block',
            fontSize: 0 // Hide any fallback text
          }}
        ></div>
      ) : (
        <div className="service-icon" aria-hidden="true">{icon}</div>
      )}
      <div className="service-content">
        <div className="credits-label">{title}</div>
        {subtitle && <div className="cardsubtext">{subtitle}</div>}
      </div>
    </button>
  );
}

CreditPackage.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.node, // ✅ Made optional since iconUrl can be used instead
  iconUrl: PropTypes.string, // ✅ New prop for image URL
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

CreditPackage.defaultProps = {
  icon: null,
  iconUrl: null,
  subtitle: '',
};

export default CreditPackage;
